import api from '../client'

export const aiApi = {
  getCapabilities: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/ai/capabilities`)
    return response.data
  },
  getConfig: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/ai/config`)
    return response.data
  },
  updateConfig: async (orgSlug, payload) => {
    const response = await api.patch(`/${orgSlug}/ai/config`, payload)
    return response.data
  },
  getUsage: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/ai/usage`, { params })
    return response.data
  },
  createImageJob: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/ai/jobs/image`, payload)
    return response.data
  },
  createTranscriptionJob: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/ai/jobs/transcription`, payload)
    return response.data
  },
  getJob: async (orgSlug, jobId) => {
    const response = await api.get(`/${orgSlug}/ai/jobs/${jobId}`)
    return response.data
  },
  retryJob: async (orgSlug, jobId) => {
    const response = await api.post(`/${orgSlug}/ai/jobs/${jobId}/retry`)
    return response.data
  },
  suggestTags: async (orgSlug, text) => {
    const response = await api.post(`/${orgSlug}/ai/suggest-tags`, { text })
    return response.data
  },
  suggestCaption: async (orgSlug, input) => {
    const payload = typeof input === 'string' ? { text: input } : { ...input }
    if (typeof payload.constraints === 'string') {
      payload.constraints = [payload.constraints]
    }
    const response = await api.post(`/${orgSlug}/ai/suggest-caption`, payload)
    return response.data
  },
  extractBetDetails: async (orgSlug, text) => {
    const response = await api.post(`/${orgSlug}/ai/extract-bet-details`, { text })
    return response.data
  },
  suggestBets: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/ai/suggest-bets`, payload)
    return response.data
  },
  generateImage: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/ai/generate-image`, payload)
    return response.data
  },
  editImage: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/ai/edit-image`, payload)
    return response.data
  },
  generatePrePackTitle: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/ai/prepack-title`, payload)
    return response.data
  },
}
